import axios from 'axios.js';
import { showSnackbar } from "./UiAction";
import axiosKeyInstance from 'axiosKeyCloak';
import Cookies from 'js-cookie';

export const UPDATE_SETTING = 'UPDATE_SETTING';
export const GET_SETTING_DATA = 'GET_SETTING_DATA';
export const GET_DISTRICT_LIST_SETTING = "GET_DISTRICT_LIST_SETTING";
export const GET_BLOCK_BY_DISTRICT_LIST_SETTING = "GET_BLOCK_BY_DISTRICT_LIST_SETTING";
export const GET_CLUSTER_BY_BLOCK_LIST__SETTING = "GET_CLUSTER_BY_BLOCK_LIST__SETTING";
export const GET_SCHOOL_BY_CLUSTER_LIST__SETTING = "GET_SCHOOL_BY_CLUSTER_LIST__SETTING";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const PASSWORD_UPDATE = "PASSWORD_UPDATE";
export const GET_USER_TOKEN = "GET_USER_TOKEN";

export const updateSetting = (data, id) => (dispatch) => { // update setting api
  axios
    .patch('/settings', data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: UPDATE_SETTING,
        payload: response.data,
      });
      dispatch(refreshToken())
      if (localStorage.getItem('userRole') === 'school') {
        dispatch(getSettingData(id))
      }
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const refreshToken = () => (dispatch) => {

  axios.get("/user/token").then((res) => {
    dispatch({
      type: GET_USER_TOKEN,
      payload: res.data,
    });

    axiosKeyInstance
      .post('/realms/users/protocol/openid-connect/token', {
        grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
        // subject_token: Cookies.get("accessToken"),
        // subject_token: localStorage.getItem("accessToken"), 
        subject_token: res.data.data, 
        client_id: "react-app",
        requested_token_type: "urn:ietf:params:oauth:token-type:refresh_token",
      })
      .then((response) => {
        dispatch({
          type: REFRESH_TOKEN,
          payload: response.data,
        });
        Cookies.set("accessToken", response.data.access_token, { secure: true, httpOnly: true });
        // localStorage.setItem("accessToken", response.data.access_token);
        if(localStorage.getItem("userRole") === 'mis'){
          Cookies.set("existing_user_id", response.data.access_token, { secure: true, httpOnly: true });
          // localStorage.setItem("existing_user_id", response.data.access_token);
        }
      })
      .catch((error) => {
        dispatch(showSnackbar(error.message, 'top', "error"));
      });
  })
  .catch((error) => {
    dispatch(showSnackbar(error.message, 'top', "error"));
  });  
};

export const getSettingData = (id) => (dispatch) => { // get setting data api
  axios
    .get(`school/time`)
    .then((response) => {
      dispatch({
        type: GET_SETTING_DATA,
        payload: response.data,
      });
    })
};

export const getDistrictListSetting = () => (dispatch) => { // get district list on global search api
  axios.get(`/search/filter/district`).then((res) => {
    dispatch({
      type: GET_DISTRICT_LIST_SETTING,
      payload: res.data,
    });
  });
};

export const getBlockByDistrictListSetting = (id) => (dispatch) => { // gt block list by district on global search api call
  axios.get(`search/filter/block/${id}`).then((res) => {
    dispatch({
      type: GET_BLOCK_BY_DISTRICT_LIST_SETTING,
      payload: res.data,
    });
  });
};

export const getClusterByBlockListSetting = (id) => (dispatch) => { // get cluster list by block on global search api call 
  axios.get(`search/filter/cluster/${id}`).then((res) => {
    dispatch({
      type: GET_CLUSTER_BY_BLOCK_LIST__SETTING,
      payload: res.data,
    });
  });
};

export const getSchoolByClusterListSetting = (id) => (dispatch) => { // get cluster list by block on global search api call 
  axios.get(`search/filter/school/${id}`).then((res) => {
    dispatch({
      type: GET_SCHOOL_BY_CLUSTER_LIST__SETTING,
      payload: res.data,
    });
  });
};

export const passwordUpdate = (data) => (dispatch) => { // update setting api
  axios
    .patch('/password/reset', data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: UPDATE_PASSWORD,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const schoolPasswordUpdate = (data) => (dispatch) => { // update password school
  axios
    .post('/password/update', data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: PASSWORD_UPDATE,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};